'use client';

import { createContext, useContext } from 'react';
export const BUTTON_VARIANT = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  sub: 'sub',
  chat: 'chat'
} as const;
export type ButtonVariant = keyof typeof BUTTON_VARIANT;

/** 정규화된 높이 토큰 */
export const BUTTON_HEIGHT = {
  h56: 'h56',
  h48: 'h48',
  h40: 'h40',
  h32: 'h32',
  h28: 'h28',
  small: 'small',
  medium: 'medium'
} as const;
export type ButtonHeight = keyof typeof BUTTON_HEIGHT;
export const BUTTON_TONE = {
  // System family
  tag1: 'system-tag1',
  red: 'system-red1',
  red2: 'system-red2',
  blue: 'system-blue',
  yellow: 'system-yellow',
  mint: 'system-mint',
  mintLight: 'system-mint-light',
  redLight: 'system-red-light',
  yellowLight: 'system-yellow-light',
  blueLight: 'system-blue-light',
  green: 'system-green',
  purple2: 'system-purple2',
  // Brand family
  brandPrimary: 'brand-primary',
  brandSecondary: 'brand-secondary',
  brandTertiary: 'brand-tertiary'
} as const;
export type ButtonTone = keyof typeof BUTTON_TONE;
export interface ButtonContextValue {
  id: string;
  variant: ButtonVariant;
  height: ButtonHeight; // ← 단일 소스
  tone?: ButtonTone;
  disabled?: boolean;
  isPending?: boolean;
}
export const ButtonContext = createContext<ButtonContextValue | null>(null);
export const useButton = () => {
  const ctx = useContext(ButtonContext);
  if (!ctx) {
    throw new Error("useButton must be used within <Button.Root>.");
  }
  return ctx;
};